import { render, staticRenderFns } from "./RuleCustomEdit.vue?vue&type=template&id=79882ec2&scoped=true&"
import script from "./RuleCustomEdit.vue?vue&type=script&lang=js&"
export * from "./RuleCustomEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79882ec2",
  null
  
)

export default component.exports